import "@ant-design/v5-patch-for-react-19";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { ProfileProvider } from "Common/hooks/context/ProfileContext";
import { SoftUIControllerProvider } from "Common/hooks/context";
import { Theme } from "Common/hooks/context/ThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <Theme>
        <ProfileProvider>   
          <App />
        </ProfileProvider>
      </Theme>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
